// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D_1pV4Kb0DItjSqC3msA{justify-content:space-between;align-items:flex-start;gap:14px;display:flex}.SjYVwvyvfYC5RNmDftbI{border:1px solid var(--interaction-neutral-normal);background:var(--background-primary-inverted-primary);border-radius:12px;padding:23.5px}.pZQRG3keugCk1kbf80i5{border:1px solid var(--interaction-brand-active);background:var(--light-blue-10)}.uKTyFtnKLM4oA0uB9Ggm{flex-direction:column;flex:1;display:flex}.FKTAzQvJNIM0H7cZfbNw{margin-top:4px}.xGOPxzLqpz8GbjEDjRnQ{margin-top:16px}.UlIdXJGSpoMupESwGYkE{flex-direction:column;justify-content:space-between;align-self:stretch;align-items:flex-end;display:flex}.bx0K9xVHNSwFLLGQ6KA0{flex-direction:row-reverse;align-items:flex-start;gap:20px}.bB6nYGDvv0wRzqldDRLC{margin-top:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `D_1pV4Kb0DItjSqC3msA`,
	"wrapBorderWithIcon": `SjYVwvyvfYC5RNmDftbI`,
	"wrapActive": `pZQRG3keugCk1kbf80i5`,
	"content": `uKTyFtnKLM4oA0uB9Ggm`,
	"freeLabel": `FKTAzQvJNIM0H7cZfbNw`,
	"description": `xGOPxzLqpz8GbjEDjRnQ`,
	"switchContainer": `UlIdXJGSpoMupESwGYkE`,
	"switchContainerHorizontal": `bx0K9xVHNSwFLLGQ6KA0`,
	"switch": `bB6nYGDvv0wRzqldDRLC`
};
export default ___CSS_LOADER_EXPORT___;
